import Vue from 'vue'

export var bus = new Vue()


// WEBPACK FOOTER //
// ./src/js/bus.js